import { Facility, Target } from "@app/shared";
import React from "react";
import { OmniGoogleMap } from "../maps/OmniGoogleMap";
import { isAttenuatorFacility } from "./attenuatorLayoutHelpers";
import { AttenuatorRoadView } from "./AttenuatorRoadView";

export type BackgroundType = "map" | "attenuator";

export function getFacilityBackgroundType(facility: Facility): BackgroundType {
    if (isAttenuatorFacility(facility)) return "attenuator";
    return "map";
}

type FacilityBackgroundViewProps = {
    facility: Facility;
    targets?: Target[];
    mapCenter?: google.maps.LatLng;
    mapChildren?: React.ReactNode;
    attenuatorOverrides?: { width?: number; length?: number };
    showLegend?: boolean;
    zoomed?: boolean;
    className?: string;
};

export const FacilityBackgroundView: React.FC<FacilityBackgroundViewProps> = ({
    facility,
    targets,
    mapCenter,
    mapChildren,
    attenuatorOverrides,
    showLegend,
    zoomed,
    className,
}) => {
    const bgType = getFacilityBackgroundType(facility);

    if (bgType === "attenuator") {
        return (
            <AttenuatorRoadView
                facility={facility}
                targets={targets}
                widthOverride={attenuatorOverrides?.width}
                lengthOverride={attenuatorOverrides?.length}
                showLegend={showLegend}
                zoomed={zoomed}
                className={className}
            />
        );
    }


    if (!mapCenter) return null;
    return (
        <OmniGoogleMap center={mapCenter} fitToPolygons={true} noWrap={true}>
            {mapChildren}
        </OmniGoogleMap>
    );
};
